import { CATEGORY_META } from "@/lib/api";

export const Logo = ({ sub = false, size = 36 }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
      <defs>
        <linearGradient id="lg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#22d3ee" />
          <stop offset=".5" stopColor="#4f6bff" />
          <stop offset="1" stopColor="#c03af5" />
        </linearGradient>
      </defs>
      <path d="M38 12A18 18 0 1 0 38 36" fill="none" stroke="url(#lg)" strokeWidth="6" strokeLinecap="round" />
      <path d="M31 18a9 9 0 1 0 0 12" fill="none" stroke="url(#lg)" strokeWidth="4" strokeLinecap="round" opacity=".8" />
    </svg>
    <div className="leading-tight">
      <div className="font-display font-semibold text-lg text-white">Casi AI Hub</div>
      {sub && <div className="text-xs text-slate-400">Casi AI Labs</div>}
    </div>
  </div>
);

export const CategoryBadge = ({ category, testid }) => {
  const m = CATEGORY_META[category] || CATEGORY_META.unknown;
  return (
    <span data-testid={testid} className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-semibold ${m.cls}`}>
      {m.label}
    </span>
  );
};

export const FreeBadge = ({ free }) =>
  free ? (
    <span className="rounded-md border border-emerald-500/30 bg-emerald-500/10 px-1.5 py-0.5 text-[10px] font-semibold text-emerald-300">Kostenlos</span>
  ) : (
    <span className="rounded-md border border-red-500/40 bg-red-500/10 px-1.5 py-0.5 text-[10px] font-semibold text-red-300">Kostenpflichtig</span>
  );

export const StatusPill = ({ state, testid }) => {
  const map = {
    ok: ["bg-emerald-400", "text-emerald-300", "Verbunden"],
    error: ["bg-red-400", "text-red-300", "Fehler"],
    untested: ["bg-amber-400", "text-amber-300", "Gespeichert, nicht getestet"],
    none: ["bg-slate-500", "text-slate-400", "Nicht konfiguriert"],
  };
  const [dot, txt, label] = map[state] || map.none;
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 text-xs font-medium ${txt}`}>
      <span className={`h-2 w-2 rounded-full ${dot} ${state === "ok" ? "pulse-dot" : ""}`} />
      {label}
    </span>
  );
};

export const credState = (cred) => (!cred ? "none" : !cred.last_test ? "untested" : cred.last_test.ok ? "ok" : "error");

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between fade-up">
    <div>
      <h1 className="text-3xl sm:text-4xl font-bold text-white" data-testid="page-title">{title}</h1>
      {subtitle && <p className="mt-2 text-sm md:text-base text-slate-400 max-w-2xl">{subtitle}</p>}
    </div>
    {children}
  </div>
);

export const EmptyState = ({ icon: Icon, title, text, action, testid }) => (
  <div data-testid={testid} className="flex flex-col items-start gap-3 rounded-xl border border-dashed border-slate-700/70 p-8">
    {Icon && <Icon className="h-6 w-6 text-slate-500" />}
    <div className="font-semibold text-slate-200">{title}</div>
    {text && <p className="text-sm text-slate-400 max-w-md">{text}</p>}
    {action}
  </div>
);
